<template>
    <swb-region ref="swb_region" :item="regionInfo" :mustParam="false" @notity-change="notityChange($event)"></swb-region>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import SwbRegion from './Region';
    Vue.regist(SwbRegion);

    export default {
        name: 'swb-region-for-select',
        desc: '地区下拉选择',
        props: {
            checkedProvinceId: {
                type: Number,
                default: null
            },
            checkedCityId: {
                type: Number,
                default: null
            },
            checkedCountyId: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                regionInfo: {}
            }
        },
        created: function () {
            this.regionInfo.provinceId = this.checkedProvinceId;
            this.regionInfo.cityId = this.checkedCityId;
            this.regionInfo.countyId = this.checkedCountyId;
            this.regionInfo.regionId = this.checkedCountyId;
            this.regionInfo = Utils.merge({}, this.regionInfo);
        },
        methods: {
            notityChange: function () {
                // 发生变化时向上传递
            },
            getDlgResult: function () {
                // 提供回调函数，返回结果
                let self = this;
                let result = {};
                //
                let regionResult = self.$refs.swb_region.getDlgResult() || {};
                if(regionResult != null) {
                    if(regionResult.type === 'info') {
                        // 处理你的信息添加赋值
                        let region = regionResult.data || null;
                        result.type = 'info';
                        if(region != null) {
                            result.data = {
                                provinceId: region.provinceId,
                                cityId: region.cityId,
                                countyId: region.countyId,
                                regionId: region.regionId
                            };
                        }
                        return result;
                    } else {
                        MsgBox.warning(regionResult.message);
                        return false;
                    }
                } else {
                    MsgBox.warning('返回出错');
                    return false;
                }
            }
        }
    }

</script>




// WEBPACK FOOTER //
// src/compo/comn/RegionForSelect.vue